import React from "react";
import { Path } from "react-native-svg";

import { IconPathProps } from "../types";

const ChevronLeft = ({ lineColor, strokeWidth }: IconPathProps) => (
  <Path
    d="M15 4.5L7.5 12L15 19.5"
    stroke={lineColor}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
  />
);

export default ChevronLeft;
